var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock4Img2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_3307",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.362 0.229492H0.362061V100.229H100.362V0.229492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.639 47.4723L54.5412 4.40399L50.3629 0.229492L17.9207 32.6498L3.0879 47.4709C2.72001 47.8387 2.42818 48.2754 2.22907 48.7561C2.02997 49.2367 1.92749 49.7518 1.92749 50.272C1.92749 50.7921 2.02997 51.3073 2.22907 51.7879C2.42818 52.2686 2.72001 52.7051 3.0879 53.0729L32.7277 82.6921L50.3629 100.314L82.8063 67.8954L83.3082 67.3934L97.639 53.0729C98.0069 52.7051 98.2988 52.2686 98.4979 51.7879C98.6969 51.3073 98.7994 50.7921 98.7994 50.272C98.7994 49.7518 98.6969 49.2367 98.4979 48.7561C98.2988 48.2754 98.0069 47.8401 97.639 47.4723ZM50.3629 65.0687L35.5571 50.2745L50.3629 35.4765L65.1699 50.2732L50.3629 65.0687Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3613 35.4763C40.6685 25.7872 40.6196 10.0946 50.2559 0.347656L17.8535 32.7152L35.4887 50.3386L50.3613 35.4763Z",
    fill: "url(#paint0_linear_44_3307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2091 50.2339L50.3621 65.0706C52.6783 67.3839 54.5158 70.1311 55.7694 73.155C57.0232 76.179 57.6685 79.4205 57.6685 82.694C57.6685 85.9676 57.0232 89.209 55.7694 92.2331C54.5158 95.257 52.6783 98.0042 50.3621 100.318L82.8441 67.8575L65.2091 50.2339Z",
    fill: "url(#paint1_linear_44_3307)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_3307",
    x1: 47.7176,
    y1: 20.508,
    x2: 22.7659,
    y2: 31.0521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_3307",
    x1: 1310.02,
    y1: 1332.91,
    x2: 1865.32,
    y2: 1181.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock4Img2);
export default __webpack_public_path__ + "static/media/block_4_img_2.60849b1238f6ae31946b32619062a7ce.svg";
export { ForwardRef as ReactComponent };